<template>
  <div align="center" class="container-fluid content">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />{{$t('currlocation')}}
      : <router-link :to="{name:'login'}">{{$t('index')}}</router-link>
      <img src="../../assets/img/jt.gif">{{$t('IM_EX_Report')}}
    </div>
    <!--第一列-->
    <div class="form-group col-sm-12 " style="padding-left: 0px;">
      <label class="col-sm-2 control-label" style="text-align:right;">
        {{$t('normal_inq_etd')}}
      </label>
      <div class="col-sm-2">
        <input type="text" class="form-control Wdate" id='st' v-model="st" @change="changeST($event)" v-on:click="datePicker('st')">
      </div>
      <div style="float: left; line-height: 30px; font-weight: bold;">
        --</div>
      <div class="col-sm-2">
        <input type="text" class="form-control" v-model="et" @change="changeET($event)" id="et" v-on:click="enddatePicker('et')">
      </div>
      <div class="col-sm-2">

      </div>
    </div>

    <!--第二列-->
    <div class="form-group col-sm-12 " style="padding-left: 0px;">
      <label class="col-sm-2 control-label" style="text-align:right;">

      </label>
      <div class="col-sm-2" style="text-align:left;">
        <!-- <el-cascader :options="options" :props="props" v-model="orgnCode" collapse-tags clearable></el-cascader> -->
        {{ $t("anonymou_orgn_code") }}:
        <el-select v-model="orgnValue" :placeholder='$t("anonymou_orgn_code")'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

      </div>
      <div class="col-sm-2" style="text-align:left;">
        {{ $t("anonymou_dest_code") }}:
        <el-select v-model="destValue" :placeholder='$t("anonymou_orgn_code")'>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="col-sm-2" style="text-align:left;">
        <button class="btn btn-primary" type="submit" style="margin-right:10px" @click.prevent="query()">
          {{$t('submit')}}
          <span style="width:20px;"></span>
          <img src="../../assets/img/submit.svg" style="width:20px;text-align:right;">

        </button>
        <a class="btn btn-info" href="javascript:;" @click="exportExcel()">
          {{$t('export_excel')}}
          <span style="width:20px;"></span>
          <img src="../../assets/img/xlsx.svg" style="width:20px;text-align:right;">
        </a>
      </div>

    </div>

    <div>
      <div class="row" v-for="areaRecord in dataList">
        <!-- 出口 -->
        <div class="col-sm-5">
          <table class="table table-bordered table-condensed " v-if=" areaRecord.exportRecord.records.length!=0">
            <tbody>
              <tr class="active">
                <th colspan="7" align="center">{{areaRecord.area}} EXPORT</th>
              </tr>
              <tr class="success">
                <td>DEST_CODE</td>
                <td>HAWB</td>
                <td>QTY</td>
                <td>G.W(KG)</td>
                <td>C.W(KG)</td>
                <td>QTY_percentage</td>
                <td>GW_percentage</td>
              </tr>
              <tr v-for="record in areaRecord.exportRecord.records">
                <td>{{record.destCode}}</td>
                <td>{{record.hawb}}</td>
                <td>{{$utils.toThousands(record.qty)}}</td>
                <td>{{$utils.toThousands(record.gw)}}</td>
                <td>{{$utils.toThousands(record.cw)}}</td>
                <td>{{record.qtYpercentage}}%</td>
                <td>{{record.gWpercentage}}%</td>
              </tr>
              <tr class="info">
                <td>{{$t('IM_EX_Report_total')}}</td>
                <td>{{areaRecord.exportRecord.totalHAWB}}</td>
                <td>{{$utils.toThousands(areaRecord.exportRecord.totalQTY)}}</td>
                <td>{{$utils.toThousands(areaRecord.exportRecord.totalGW)}}</td>
                <td>{{$utils.toThousands(areaRecord.exportRecord.totalCW)}}</td>
                <td>100%</td>
                <td>100%</td>
                <!-- <td>{{$utils.FourNumber(areaRecord.exportRecord.totalqtYpercentage)}}%</td>
                <td>{{$utils.FourNumber(areaRecord.exportRecord.totalgWpercentage)}}%</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-1"></div>
        <div class="col-sm-5">
          <table class="table table-bordered table-condensed " v-if="areaRecord.importRecord.records.length!=0">
            <tbody>
              <tr class="active">
                <th colspan="7" align="center">{{areaRecord.area}} IMPORT</th>
              </tr>
              <tr class="success">
                <td>ORGN_CODE</td>
                <td>HAWB</td>
                <td>QTY</td>
                <td>G.W(KG)</td>
                <td>C.W(KG)</td>
                <td>QTY_percentage</td>
                <td>GW_percentage</td>
                <!-- <td>{{areaRecord.importRecord.records.length}}</td> -->
              </tr>
              <tr v-for="record in areaRecord.importRecord.records">
                <td>{{record.orgnCode}}</td>
                <td>{{record.hawb}}</td>
                <td>{{$utils.toThousands(record.qty)}}</td>
                <td>{{$utils.toThousands(record.gw)}}</td>
                <td>{{$utils.toThousands(record.cw)}}</td>
                <td>{{record.qtYpercentage}}%</td>
                <td>{{record.gWpercentage}}%</td>
              </tr>
              <tr class="info">
                <td>{{$t('IM_EX_Report_total')}}</td>
                <td>{{areaRecord.importRecord.totalHAWB}}</td>
                <td>{{$utils.toThousands(areaRecord.importRecord.totalQTY)}}</td>
                <td>{{$utils.toThousands(areaRecord.importRecord.totalGW)}}</td>
                <td>{{$utils.toThousands(areaRecord.importRecord.totalCW)}}</td>
                <td>100%</td>
                <td>100%</td>
                <!-- <td>{{$utils.FourNumber(areaRecord.importRecord.totalqtYpercentage)}}%</td>
                <td>{{$utils.FourNumber(areaRecord.importRecord.totalgWpercentage)}}%</td>  -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import { reportQuery } from "@/api/TransportReport";

export default {
  components: {
    PageHeader,
  },
  data () {
    return {
      st: "",
      et: "",
      areas: ["HKG", "SIN", "TPE", "PVG", "MY"],
      records: [],
      charts: "",
      chartList: [],
      orgnCode: [],
      destCode: [],
      props: { multiple: true },
      options: [
        {
          value: "",
          label: "ALL",
        },
        {
          value: "HKG",
          label: "HKG",
        },
        {
          value: "SIN",
          label: "SIN",
        },
        {
          value: "TPE",
          label: "TPE",
        },
        {
          value: "PVG",
          label: "PVG",
        },
        {
          value: "MY",
          label: "MY",
        },
      ],
      orgnValue: "",
      destValue: "",
      dataList: [],
    };
  },
  mounted () {
    // this.query();
    // this.$nextTick(function () {
    //   // this.drawLine("main");
    // });
  },
  methods: {
    /**
     * 计算总数
     */
    calculateTotal (obj, records) {
      var shuzu = [];
      var shuzuqtY = [];
      for (var i = 0; i < records.length; i++) {
        obj.totalHAWB += records[i].hawb;
        obj.totalQTY += records[i].qty;
        obj.totalGW += records[i].gw;
        obj.totalCW += records[i].cw;
        shuzu.push(records[i].gw);
        shuzuqtY.push(records[i].qty);
        //obj.totalqtYpercentage += records[i].qtYpercentage;
        // obj.totalgWpercentage += records[i].gWpercentage;
      }
      obj.totalCW = Math.floor(obj.totalCW * 10) / 10;
      obj.totalGW = Math.floor(obj.totalGW * 10) / 10;
      //计算百分比,相加之和为100%
      for (var k = 0; k < records.length; k++) {
        // var zhi = this.$utils.getPercentValue(shuzu, k, 2);
        // records[k].gWpercentage = zhi;
        // var zhiQTy = this.$utils.getPercentValue(shuzuqtY, k, 2);
        // records[k].qtYpercentage = zhiQTy;
        records[k].gWpercentage = this.GetPercent(records[k].gw, obj.totalGW);
        records[k].qtYpercentage = this.GetPercent(
          records[k].qty,
          obj.totalQTY
        );
      }
    },
    async query () {
      this.setQueryWhere();
      this.orgnCode = [];
      var orgnValue = this.orgnValue;
      var destValue = this.destValue;
      if (orgnValue == "MY" && destValue == "MY") {
        this.orgnCode.push(["MY", "MY"]);
        this.orgnCode.push(["PEN", "PEN"]);
        this.orgnCode.push(["KUL", "KUL"]);
        this.orgnCode.push(["KUL", "MY"]);
        this.orgnCode.push(["KUL", "PEN"]);
        this.orgnCode.push(["MY", "KUL"]);
        this.orgnCode.push(["MY", "PEN"]);
        this.orgnCode.push(["PEN", "KUL"]);
        this.orgnCode.push(["PEN", "MY"]);
      }
      if (orgnValue == "MY" && destValue != "MY") {
        this.orgnCode.push(["MY", destValue]);
        this.orgnCode.push(["PEN", destValue]);
        this.orgnCode.push(["KUL", destValue]);
      }
      if (orgnValue != "MY" && destValue == "MY") {
        this.orgnCode.push([orgnValue, "MY"]);
        this.orgnCode.push([orgnValue, "PEN"]);
        this.orgnCode.push([orgnValue, "KUL"]);
      }

      if (
        (orgnValue != "" || destValue != "") &&
        orgnValue != "MY" &&
        destValue != "MY"
      ) {
        this.orgnCode.push([orgnValue, destValue]);
      }

      var res = await reportQuery({
        st: this.st,
        et: this.et,
        //  destCodeList:this.destCode,
        orgnCodeList: this.orgnCode,
      }).getResponseAsync();
      if (res == null) {
        return;
      }

      this.records = res.data;
      this.areaRecords();
      return false;
    },
    /**
     * 设置查询条件
     */
    setQueryWhere () {
      var currentDate = new Date();
      if (this.st == "") {
        this.st = this.$utils.dateFormat(currentDate, "yyyyMM01");
      }
      if (this.et == "") {
        this.et = this.$utils.dateFormat(currentDate, "yyyyMMdd");
      }
    },
    changeET (event) {
      this.et = event.target.value;
    },
    changeST (event) {
      this.st = event.target.value;
    },
    exportExcel () {
      this.setQueryWhere();
      var fileName = this.$utils.dateFormat(new Date(), "yyyyMMddIM_EX_Report");
      this.$utils.downloadFile(
        this.apiUrl +
        "TransportReport/ExportReportRecords?ST=" +
        this.st +
        "&ET=" +
        this.et +
        "&orgnCodeList=" +
        this.orgnCode,
        fileName
      );
    },

    GetPercent (num, total) {
      /// <summary>
      /// 求百分比
      /// </summary>
      /// <param name="num">当前数</param>
      /// <param name="total">总数</param>
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      var baifenbi =
        total <= 0 ? "0%" : Math.round((num / total) * 10000) / 100.0;

      return baifenbi;
    },
    Percentage (num, total) {
      if (num == 0 || total == 0) {
        return 0;
      }
      var baifenbi = Math.round((num / total) * 10000) / 100.0;
      return baifenbi; // 小数点后两位百分比
    },
    areaRecords () {
      var entity = this.areas.map((area) => {
        var obj = {
          area: area,
          exportRecord: {
            records: [],
            totalHAWB: 0,
            totalQTY: 0,
            totalGW: 0,
            totalCW: 0,
            totalqtYpercentage: 0,
            totalgWpercentage: 0,
          },
          importRecord: {
            records: [],
            totalHAWB: 0,
            totalQTY: 0,
            totalGW: 0,
            totalCW: 0,
            totalqtYpercentage: 0,
            totalgWpercentage: 0,
          },
        };

        obj.exportRecord.records = JSON.parse(
          JSON.stringify(
            this.records.filter((a) => {
              // console.log(this.destValue);
              if (this.orgnValue == "" && this.destValue != "") {
                return (
                  a.orgnCode == area && area == this.destValue && area == a.orgnCode ||
                  (area == "MY" && (a.orgnCode == "PEN" || a.orgnCode == "KUL") && area == a.orgnCode)
                );
              }
              return (
                a.orgnCode == area ||
                (area == "MY" && (a.orgnCode == "PEN" || a.orgnCode == "KUL"))
              );
            })
          )
        );
        obj.importRecord.records = JSON.parse(
          JSON.stringify(
            this.records.filter((a) => {
              if (this.orgnValue != "" && this.destValue == "") {
                return (
                  a.destValue == area && area == this.orgnValue && area == a.destValue ||
                  (area == "MY" && (a.orgnCode == "PEN" || a.orgnCode == "KUL") && area == a.orgnCode)
                );
              }

              return (
                a.destCode == area ||
                (area == "MY" && (a.destCode == "PEN" || a.destCode == "KUL"))
              );
            })
          )
        );
        this.calculateTotal(obj.exportRecord, obj.exportRecord.records);
        this.calculateTotal(obj.importRecord, obj.importRecord.records);
        return obj;
      });
      // console.log(entity);
      this.dataList = entity;
    },
    datePicker: function (elementId) {
      let vueObj = this;
      WdatePicker({
        el: elementId,
        lang: vueObj.$store.state.lang,
        dateFmt: "yyyyMMdd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.st = value;
        },
        oncleared: function () {
          vueObj.st = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
    enddatePicker: function (elementId) {

      let vueObj = this;
      WdatePicker({
        el: elementId,
        lang: vueObj.$store.state.lang,
        dateFmt: "yyyyMMdd", //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $("#" + elementId).val();
          vueObj.et = value;
        },
        oncleared: function () {
          vueObj.et = null;
        },
        isShowClear: true,
        readOnly: true,
      });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: 100%;
}
@import "../../assets/css/index.css";
</style>